/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
  UncontrolledTooltip,
  InputGroup,
} from "reactstrap";

import Select from "react-select";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

//importcomponent balancing
import BalancingComponent from "../../components/Skills/Balancer/BalancingComponent";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import "./Skill.scss";
import schema, { schemaChannelPhone } from "./SkillValidation.js";

//Lodash
import { isEqual } from "lodash";

import {
  getSkill,
  createSkill,
  editSkill,
  resetSkill,
  resetSkills,
  resetError,
} from "../../store/skills/actions";

// customDatepicker
import CustomDatePicker2 from "../../components/Common/CustomDatePicker2";
import CustomColorPicker from "../../components/Common/CustomColorPicker";
import CustomInputNumber from "../../components/Common/CustomInputNumber";

import ChatEvent from "../../components/Skills/ChatEvent/ChatEvent";
import InputTime from "../../components/Skills/ChatEvent/inputTime";
import SwitchEvent from "../../components/Skills/ChatEvent/SwitchEvent";
import { isArray, sortArrayBy } from "../../Libs/CustomMethods/customMethods";

const NewSkill = ({ t }) => {
  let { idSkill } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataSkillGetSet,
    dataSkillEditCreate,
    loadingSkill,
    loadingSkillEditCreate,
    successSkill,
    errorSkill,
  } = useSelector((state) => state.Skill);

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [isAutoClose, setIsAutoClose] = useState(true);

  const [minQueuePriority] = useState(0);
  const [maxQueuePriority] = useState(20);
  const [stepQueuePriority] = useState(1);

  const [minInactiveChat] = useState(0.01);
  const [maxInactiveChat] = useState(1);
  const [stepInactiveChat] = useState(0.01);

  const [skillValues, setSkillValues] = useState({
    name: "",
    nameBk: "",

    color: "",
    colorBk: "",

    inactivity_time: "",
    inactivity_timeBk: "",

    weight_active: "",
    weight_activeBk: "",

    weight_inactive: "",
    weight_inactiveBk: "",

    schedules: [],
    schedulesBk: [],

    transfer: [],
    transferBk: [],

    users: [],
    usersBk: [],

    fallback: "",
    fallbackBk: "",

    fallback_no_agents: false,
    fallback_no_agentsBk: false,

    sla: [],
    slaBk: [],

    queuepriority: [],
    queuepriorityBk: [],

    csat_id: "",
    csat_idBk: "",

    automatic_close_time: "",
    automatic_close_timeBk: "",

    automatic_transfer_time: "",
    automatic_transfer_timeBk: "",

    automatic_transfer_skill: null,
    automatic_transfer_skillBk: null,

    client_idle_time: "",
    client_idle_timeBk: "",

    queue_idle_time: "",
    queue_idle_timeBk: "",

    agent_idle_time: "",
    agent_idle_timeBk: "",

    return_option_close: false,
    return_option_closeBk: false,

    type: null,
    typeBk: null,

    widget: false,
    widgetBk: false,

    channel_phone: false,
    channel_phoneBk: false,

    sla_count: false,
    sla_countBk: false,

    enable_cloning: false,
    enable_cloningBk: false,

    is_ai_summary_enabled: false,
    is_ai_summary_enabledBk: false,
    
    enable_priorityBk: false,
    enable_priority: false,

    enable_lock_skillBk: false,
    enable_lock_skill: false,

    objBalancer: {},
    objBalancerBk: {},
  });

  const minActiveChat = useMemo(() => {
    return skillValues.channel_phone ? 0 : 1;
  }, [skillValues.channel_phone]);
  const [maxActiveChat] = useState(3);
  const stepActiveChat = useMemo(() => {
    return skillValues.channel_phone ? 0 : 1;
  }, [skillValues.channel_phone]);

  const resolverYup = useMemo(() => {
    if (skillValues.channel_phone) {
      return yupResolver(schema.concat(schemaChannelPhone));
    }
    return yupResolver(schema);
  }, [skillValues.channel_phone]);

  const { register, handleSubmit, errors, setValue, clearErrors } = useForm({
    resolver: resolverYup,
  });

  useEffect(() => {
    clearErrors();
  }, [resolverYup]);

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const showToast = useCallback(
    (type, message) => {
      toastr[type](message);
    },
    [successSkill]
  );
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successSkill &&
      dispatch(resetSkill()) &&
      dispatch(resetSkills()) &&
      history.push("/skills"),
  };

  const addRemoveUsers = (auxNewValues) => {
    let prevUser = skillValues?.usersBk;
    let nowUser = auxNewValues?.users;

    if (isArray(prevUser) && isArray(nowUser)) {
      let remove = prevUser.filter((x) => !nowUser.includes(x));
      let add = nowUser.filter((x) => !prevUser.includes(x));

      delete auxNewValues.users;

      auxNewValues.users_remove = remove;
      auxNewValues.users_add = add;
    }

    return auxNewValues;
  };

  const handleCreateEditSkill = () => {
    let auxNewValues = { ...newFields, waiting_time: 0 };
    if (auxNewValues?.objBalancer?.balancer === true) {
      auxNewValues.balancer = auxNewValues?.objBalancer?.balancer;
      auxNewValues.balancer_type = auxNewValues?.objBalancer?.balancer_type;
      auxNewValues.balancer_config =
        auxNewValues?.objBalancer?.balancer_config?.map((e) =>
          e.carga
            ? { id: e.group.id, name: e.group.name, carga: e.carga }
            : { id: e.group.id, name: e.group.name }
        );
      auxNewValues.balancer_timeout =
        auxNewValues?.objBalancer?.balancer_timeout;
      delete auxNewValues.objBalancer;
    } else {
      auxNewValues.balancer = false;
      delete auxNewValues.objBalancer;
    }
    if (newFields.automatic_close_time) {
      auxNewValues.automatic_transfer_skill = null;
      auxNewValues.automatic_transfer_time = null;
    }
    if (
      newFields.automatic_transfer_skill &&
      newFields.automatic_transfer_time
    ) {
      auxNewValues.automatic_close_time = null;
    }
    if (idSkill) {
      auxNewValues = addRemoveUsers(auxNewValues);

      dispatch(editSkill(idSkill, auxNewValues));
    } else {
      dispatch(createSkill(auxNewValues));
    }
  };

  const newSkillSubmit = () => {
    handleCreateEditSkill();
  };

  const arrayEquals = (a, b) => {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index])
    );
  };

  const addDaysFormat = (valuesBk) => {
    const formatDay = (dayday) => {
      return dayday !== undefined
        ? dayday
            .map((e) => {
              return {
                day: e.day,
                start: e.start,
                end: e.end,
              };
            })
            .sort((a, b) => a.day - b.day)
        : [];
    };

    const dataBk = formatDay(valuesBk);

    return (userValue) => {
      const dataUser = formatDay(userValue);

      return (
        dataBk?.length === dataUser?.length &&
        dataBk?.every(
          (val, index) =>
            parseInt(val.day, 10) === parseInt(dataUser[index].day, 10) &&
            val.start === dataUser[index].start &&
            val.end === dataUser[index].end
        )
      );
    };
  };

  const checkSchedules = (values, valuesBk) => {
    if (values !== null) {
      let aux = [];

      const checkDays = addDaysFormat(valuesBk);
      const change = checkDays(values);

      if (change) {
        delete newFields.schedules;
        checkSubmit();
      } else {
        values.forEach((val) => {
          aux.push({
            week_day: parseInt(val.day),
            hour_start: parseInt(val.start.slice(0, 2)),
            minute_start: parseInt(val.start.slice(3, 5)),
            hour_end: parseInt(val.end.slice(0, 2)),
            minute_end: parseInt(val.end.slice(3, 5)),
          });
        });
        setNewFields({
          ...newFields,
          schedules: aux,
        });
      }
    } else {
      let aux1 = [];
      let aux2 = valuesBk !== undefined ? valuesBk.map((e) => e.id) : [];

      if (arrayEquals(aux1, aux2)) {
        delete newFields.schedules;
        checkSubmit();
      } else {
        setNewFields((prev) => ({
          ...prev,
          schedules: [],
        }));
      }
    }
  };

  const addDaysFormatHoliday = (valuesBk) => {
    const formatDayHoliday = (daydateHoliday) => {
      return daydateHoliday !== undefined
        ? daydateHoliday
            .map((e) => {
              return {
                daydate: e.daydate,
                start: e.start,
                end: e.end,
              };
            })
            .sort((x, y) => {
              const time1 = parseFloat(
                x.start.replace(":", ".").replace(/[^\d.-]/g, "")
              );
              const time2 = parseFloat(
                y.start.replace(":", ".").replace(/[^\d.-]/g, "")
              );
              return time1 - time2;
            })
        : [];
    };

    const dataBk = formatDayHoliday(valuesBk);

    return (userValue) => {
      const dataUser = formatDayHoliday(userValue);

      return (
        dataBk?.length === dataUser?.length &&
        dataBk?.every(
          (val, index) =>
            parseInt(val.daydate, 10) ===
              parseInt(dataUser[index].daydate, 10) &&
            val.start === dataUser[index].start &&
            val.end === dataUser[index].end
        )
      );
    };
  };

  const checkSelects = (values, valuesBk, target) => {
    let sortedData = isArray(values) ? values.sort() : values;
    let sortedDataBk = isArray(valuesBk) ? valuesBk.sort() : valuesBk;

    let isEqual = JSON.stringify(sortedDataBk) === JSON.stringify(sortedData);

    if (isEqual) {
      delete newFields?.[target];
      checkSubmit();
    } else {
      setNewFields((prev) => ({
        ...prev,
        [target]: values,
      }));
    }
  };

  const checkSLAs = (values, valuesBk) => {
    if (JSON.stringify(values) === JSON.stringify(valuesBk)) {
      delete newFields.sla;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        sla: values.map((item) => ({
          sla_id: item.id,
          name: item.name,
          value: item.value,
        })),
      });
    }
  };

  const checkQueuePriorities = (values, valuesBk) => {
    if (JSON.stringify(values) === JSON.stringify(valuesBk)) {
      delete newFields.queue_priority;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        queue_priority: values.map((item) => ({
          queue_priority_id: item.id,
          name: item.name,
          value: item.value,
          factor: item.factor,
        })),
      });
    }
  };

  const checkInput = (field, values) => {
    let valuesBk = field + "Bk";

    if (values === skillValues[valuesBk]) {
      delete newFields[field];
      checkSubmit();
    } else {
      setNewFields((prev) => ({
        ...prev,
        [field]: values,
      }));
    }
  };

  const checkAutomaticTransfer = (val) => {
    if (
      val?.value !== skillValues.automatic_transfer_timeBk ||
      val?.skill !== skillValues.automatic_transfer_skillBk
    ) {
      setNewFields((prev) => ({
        ...prev,
        automatic_transfer_time: val?.value,
        automatic_transfer_skill: val?.skill,
      }));
    } else {
      delete newFields.automatic_transfer_time;
      delete newFields.automatic_transfer_skill;
      checkSubmit();
    }
  };

  const optionsSkills = () => {
    let skills = [];

    if (dataSkillGetSet?.data?.form?.skill?.length > 0) {
      if (idSkill) {
        dataSkillGetSet.data.form.skill.map(
          (skill) =>
            skill.id !== idSkill &&
            skills.push({
              key: skill.id,
              value: skill.id,
              label: skill.name,
            })
        );
      } else {
        dataSkillGetSet.data.form.skill.map((skill) =>
          skills.push({
            key: skill.id,
            value: skill.id,
            label: skill.name,
          })
        );
      }
    } else {
      if (loadingSkill) {
        skills.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        skills.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return sortArrayBy(skills, "label");
  };

  const getOptions = (target) => {
    let options = [];

    if (dataSkillGetSet?.data?.form?.[target]?.length > 0) {
      dataSkillGetSet.data.form[target].map((e) =>
        options.push({
          key: e.id,
          value: e.id,
          label: e.name,
        })
      );
    } else {
      if (loadingSkill) {
        options.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return sortArrayBy(options, "label");
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length > 0) {
      if (
        newFields?.objBalancer?.balancer &&
        newFields?.objBalancer?.balancer_type === "proportional"
      ) {
        // TODO: improve, there's a bug here. When edit skill with proportional balancing this enable confirm button.
        // when it changes from proportional to sequential it allows confirming without any groups,
        // after returning to the editing page it returns the old groups of proportional balancing
        if (newFields?.objBalancer?.percentTotal) {
          setEnableSubmit(true);
        } else {
          setEnableSubmit(false);
        }
      } else {
        setEnableSubmit(true);
      }
    } else setEnableSubmit(false);
  };

  const chatEvents = () => {
    return (
      <Row>
        <Col xs="12">
          <Label id="skill-chat-events">{t("Conversation events")}</Label>
        </Col>
        <Col xs="12">
          <ChatEvent
            id="autoClose"
            title="Auto close (for inactive conversations)"
            description="Close inactive conversations after"
            tooltip="Default interval to close a conversation with consumer"
            defaultValue={skillValues.automatic_close_timeBk}
            disabled={!isAutoClose}
            isLoading={loadingSkill}
            setDisabled={setIsAutoClose}
            onChange={(val) => {
              setSkillValues({
                ...skillValues,
                automatic_close_time: val?.value,
              });
              delete newFields.automatic_transfer_time;
              delete newFields.automatic_transfer_skill;
              checkInput("automatic_close_time", val?.value);
            }}
          />
        </Col>
        <Col xs="12">
          <ChatEvent
            id="autoTranfer"
            title="Auto transfer (for inactive conversations)"
            description="after"
            descriptionSkill="Transfer inactive conversations to skill"
            tooltip="Default interval to transfer a conversation with consumer to another skill"
            defaultValue={skillValues.automatic_transfer_timeBk}
            defaultSkill={skillValues.automatic_transfer_skillBk}
            options={optionsSkills()}
            disabled={isAutoClose}
            isLoading={loadingSkill}
            setDisabled={setIsAutoClose}
            onChange={(val) => {
              setSkillValues({
                ...skillValues,
                automatic_transfer_time: val?.value,
                automatic_transfer_skill: val?.skill,
              });
              delete newFields.automatic_close_time;
              checkAutomaticTransfer(val);
            }}
          />
        </Col>
        <Col xs="12">
          <ChatEvent
            id="clientIdle"
            title="Client idle time"
            description="Send a message to consumer after"
            tooltip="Default interval to send a message during client idle time"
            defaultValue={skillValues.client_idle_timeBk}
            isLoading={loadingSkill}
            onChange={(val) => {
              setSkillValues({
                ...skillValues,
                client_idle_time: val?.value,
              });
              checkInput("client_idle_time", val?.value);
            }}
          />
        </Col>
        <Col xs="12">
          <ChatEvent
            id="queueIdle"
            title="Queue idle time"
            description="Send a message to consumer after"
            tooltip="Default interval to send a message to a consumer in queue"
            defaultValue={skillValues.queue_idle_timeBk}
            isLoading={loadingSkill}
            onChange={(val) => {
              setSkillValues({
                ...skillValues,
                queue_idle_time: val?.value,
              });
              checkInput("queue_idle_time", val?.value);
            }}
          />
        </Col>
        <Col xs="12">
          <ChatEvent
            id="agentIdle"
            title="Agent idle time"
            description="Send a message to consumer after"
            tooltip="Default interval to send a message during agent idle time"
            defaultValue={skillValues.agent_idle_timeBk}
            isLoading={loadingSkill}
            onChange={(val) => {
              setSkillValues({
                ...skillValues,
                agent_idle_time: val?.value,
              });
              checkInput("agent_idle_time", val?.value);
            }}
          />
        </Col>

        <Col xs="12">
          <SwitchEvent
            id="returnOptionComponent"
            title="Auto close (return from inactivity)"
            tooltip="Close the conversation when returning from inactivity"
            value={skillValues.return_option_close}
            onChange={(val) => {
              setSkillValues((prev) => ({
                ...prev,
                return_option_close: val,
              }));
              checkInput("return_option_close", val);
            }}
          />
        </Col>

        <Col xs="12">
          <SwitchEvent
            id="idlenessComponent"
            title="Idleness"
            tooltip="Allow an idleness setting to be attached to this skill"
            value={skillValues.type}
            onChange={(val) => {
              setSkillValues((prev) => ({
                ...prev,
                type: val,
              }));
              const aux = val ? "idleness" : null;
              checkInput("type", aux);
            }}
          />
        </Col>
        <Col xs="12">
          <SwitchEvent
            id="usabilityComponent"
            title="Usability"
            tooltip="This button enable the setting usability to be used in this skill"
            value={skillValues.widget}
            onChange={(val) => {
              setSkillValues((prev) => ({
                ...prev,
                widget: val,
              }));
              checkInput("widget", val);
            }}
          />
        </Col>
        <Col xs="12">
          <SwitchEvent
            id="channelPhoneComponent"
            title="Offline Service"
            className={setClassName(errors.channel_phone)}
            tooltip="This button allows you to assign the active conversation weight to 0"
            value={skillValues.channel_phone}
            onChange={(val) => {
              setSkillValues((prev) => ({
                ...prev,
                channel_phone: val,
              }));
              checkInput("channel_phone", val);
            }}
          />
        </Col>
        <Col xs="12">
          <SwitchEvent
            id="slaCountToogle"
            title="Sla Count Toggle"
            tooltip="Trigger this button to disable the sla counting outside the normal attendance or on exception hours"
            value={skillValues.sla_count}
            onChange={(val) => {
              setSkillValues((prev) => ({
                ...prev,
                sla_count: val,
              }));
              checkInput("sla_count", val);
            }}
          />
        </Col>
        <Col xs="12">
          <SwitchEvent
            id="allowCloning"
            title="Allow Cloning"
            tooltip="Click the button to enable ticket cloning in this skill"
            value={skillValues.enable_cloning}
            onChange={(val) => {
              setSkillValues((prev) => ({
                ...prev,
                enable_cloning: val,
              }));
              checkInput("enable_cloning", val);
            }}
          />  
        </Col>  
        <Col xs="12">
          <SwitchEvent
            id="enablePriorityToogle"
            title="Possibility to assign a priority during the queue to tickets transferred to this skill"
            tooltip="Allows this skill to receive higher priority tickets while queuing"
            value={skillValues.enable_priority}
            onChange={(val) => {
              setSkillValues((prev) => ({
                ...prev,
                enable_priority: val,
              }));
              checkInput("enable_priority", val);
            }}
          />            
        </Col>
        <Col xs="12">
          <SwitchEvent
            id="enableLockToogle"
            title="Do not allow transferring engagements to this skill when outside office hours and/or with no agents logged in"
            value={skillValues.enable_lock_skill}
            onChange={(val) => {
              setSkillValues((prev) => ({
                ...prev,
                enable_lock_skill: val,
              }));
              checkInput("enable_lock_skill", val);
            }}
          />            
        </Col>
        {dataSkillGetSet?.data?.form?.ai_summary ? (
        <Col xs="12">
          <SwitchEvent
            id="allowSummarization"
            title="Allow summarization"
            tooltip="Click the button to enable summarization in this skill"
            value={skillValues.is_ai_summary_enabled}
            onChange={(val) => {
              setSkillValues((prev) => ({
                ...prev,
                is_ai_summary_enabled: val,
              }));
              checkInput("is_ai_summary_enabled", val);
            }}
          />  
        </Col> 
      ) : ''}
  
      </Row>
    );
  };

  useEffect(() => {
    if (idSkill) {
      dispatch(getSkill(idSkill, true));
    } else {
      dispatch(getSkill(null, true));
    }
  }, []);

  useEffect(() => {
    if (dataSkillGetSet?.data?.form) {
      setSkillValues({
        ...skillValues,
        sla: dataSkillGetSet.data.form.sla.map((sla, key) =>
          key !== 1
            ? {
                key: key,
                id: sla.id,
                name: sla.name,
                value: "",
              }
            : { key: key, id: sla.id, name: sla.name, value: "30" }
        ),
        slaBk: dataSkillGetSet.data.form.sla.map((sla, key) =>
          key !== 1
            ? {
                key: key,
                id: sla.id,
                name: sla.name,
                value: "",
              }
            : { key: key, id: sla.id, name: sla.name, value: "30" }
        ),
        queuepriority: dataSkillGetSet.data.form.queue_priority.map(
          (queuepriority, key) =>
            key !== 2
              ? {
                  key: key,
                  id: queuepriority.id,
                  name: queuepriority.name,
                  value: "",
                  factor: "multi",
                }
              : {
                  key: key,
                  id: queuepriority.id,
                  name: queuepriority.name,
                  value: "3",
                  factor: "multi",
                }
        ),
        queuepriorityBk: dataSkillGetSet.data.form.queue_priority.map(
          (queuepriority, key) =>
            key !== 2
              ? {
                  key: key,
                  id: queuepriority.id,
                  name: queuepriority.name,
                  value: "",
                  factor: "multi",
                }
              : {
                  key: key,
                  id: queuepriority.id,
                  name: queuepriority.name,
                  value: "3",
                  factor: "multi",
                }
        ),
      });
    }
    if (idSkill && dataSkillGetSet?.data?.skill && !loadingSkill) {
      if (
        dataSkillGetSet.data.skill?.automatic_transfer_time &&
        dataSkillGetSet.data.skill?.automatic_transfer_skill
      ) {
        setIsAutoClose(false);
      }

      const slTime = dataSkillGetSet.data.skill?.service_level?.time;
      if (slTime) {
        setValue("skillsltime", slTime, {
          shouldValidate: true,
        });
      }

      const slGoal = dataSkillGetSet.data.skill?.service_level?.goal;
      if (slGoal) {
        setValue("skillslgoal", slGoal, {
          shouldValidate: true,
        });
      }
      
      setSkillValues({
        ...skillValues,
        name: dataSkillGetSet.data.skill?.name,
        nameBk: dataSkillGetSet.data.skill?.name,

        color: dataSkillGetSet.data.skill?.color
          ? dataSkillGetSet.data.skill?.color
          : "",
        colorBk: dataSkillGetSet.data.skill?.color
          ? dataSkillGetSet.data.skill?.color
          : "",

        inactivity_time: dataSkillGetSet.data.skill?.inactivity_time
          ? dataSkillGetSet.data.skill?.inactivity_time
          : "",
        inactivity_timeBk: dataSkillGetSet.data.skill?.inactivity_time
          ? dataSkillGetSet.data.skill?.inactivity_time
          : "",

        weight_active:
          dataSkillGetSet.data.skill?.weight_active >= 0
            ? dataSkillGetSet.data.skill?.weight_active
            : "",
        weight_activeBk:
          dataSkillGetSet.data.skill?.weight_active >= 0
            ? dataSkillGetSet.data.skill?.weight_active
            : "",

        weight_inactive:
          dataSkillGetSet.data.skill?.weight_inactive >= 0
            ? dataSkillGetSet.data.skill?.weight_inactive
            : "",
        weight_inactiveBk: dataSkillGetSet.data.skill?.weight_inactive
          ? dataSkillGetSet.data.skill?.weight_inactive >= 0
          : "",

        schedules:
          dataSkillGetSet.data.skill?.schedules &&
          dataSkillGetSet.data.skill?.schedules.length > 0
            ? dataSkillGetSet.data.skill?.schedules.map((e) => {
                let d = e.week_day;
                let h_s = ("0" + e.hour_start).slice(-2);
                let m_s = ("0" + e.minute_start).slice(-2);
                let h_e = ("0" + e.hour_end).slice(-2);
                let m_e = ("0" + e.minute_end).slice(-2);

                return {
                  daydate: t(days[d]),
                  day: d,
                  start: `${h_s}:${m_s}`,
                  end: `${h_e}:${m_e}`,
                };
              })
            : [],
        schedulesBk:
          dataSkillGetSet.data.skill?.schedules &&
          dataSkillGetSet.data.skill?.schedules.length > 0
            ? dataSkillGetSet.data.skill?.schedules.map((e) => {
                let d = e.week_day;
                let h_s = ("0" + e.hour_start).slice(-2);
                let m_s = ("0" + e.minute_start).slice(-2);
                let h_e = ("0" + e.hour_end).slice(-2);
                let m_e = ("0" + e.minute_end).slice(-2);

                return {
                  daydate: t(days[d]),
                  day: d,
                  start: `${h_s}:${m_s}`,
                  end: `${h_e}:${m_e}`,
                };
              })
            : [],

        fallback: dataSkillGetSet.data.skill?.fallback?.id ?? null,
        fallbackBk: dataSkillGetSet.data.skill?.fallback?.id ?? null,

        fallback_no_agents: dataSkillGetSet.data.skill?.fallback_no_agents,
        fallback_no_agentsBk: dataSkillGetSet.data.skill?.fallback_no_agents,

        transfer:
          dataSkillGetSet.data.skill?.transfer?.length > 0
            ? dataSkillGetSet.data.skill?.transfer.map((e) => e.id)
            : [],
        transferBk:
          dataSkillGetSet.data.skill?.transfer?.length > 0
            ? dataSkillGetSet.data.skill?.transfer.map((e) => e.id)
            : [],

        users:
          dataSkillGetSet.data.skill?.users?.length > 0
            ? dataSkillGetSet.data.skill?.users.map((e) => e.id)
            : [],
        usersBk:
          dataSkillGetSet.data.skill?.users?.length > 0
            ? dataSkillGetSet.data.skill?.users.map((e) => e.id)
            : [],

        sla:
          dataSkillGetSet.data?.form &&
          dataSkillGetSet.data?.form.sla.map((item, key) => {
            if (dataSkillGetSet.data.skill?.sla) {
              setValue(
                `skillslas[${key}].value`,
                dataSkillGetSet.data.skill?.sla[key].value
              );
            }
            return dataSkillGetSet.data.skill?.sla
              ? Object.assign(item, dataSkillGetSet.data.skill?.sla[key])
              : item;
          }),
        slaBk:
          dataSkillGetSet.data?.form &&
          dataSkillGetSet.data?.form.sla.map((item, key) =>
            dataSkillGetSet.data.skill?.sla
              ? Object.assign(item, dataSkillGetSet.data.skill?.sla[key])
              : item
          ),

        queuepriority:
          dataSkillGetSet.data?.form &&
          dataSkillGetSet.data?.form?.queue_priority?.map((item, key) =>
            dataSkillGetSet.data.skill?.queue_priority
              ? Object.assign(
                  item,
                  dataSkillGetSet.data.skill?.queue_priority[key]
                )
              : item
          ),
        queuepriorityBk:
          dataSkillGetSet.data?.form &&
          dataSkillGetSet.data?.form.queue_priority.map((item, key) =>
            dataSkillGetSet.data.skill?.queue_priority
              ? Object.assign(
                  item,
                  dataSkillGetSet.data.skill?.queue_priority[key]
                )
              : item
          ),

        csat_id: dataSkillGetSet.data.skill?.csat?.id ?? null,
        csat_idBk: dataSkillGetSet.data.skill?.csat?.id ?? null,

        service_level: dataSkillGetSet.data.skill?.service_level ?? {},
        service_levelBk: dataSkillGetSet.data.skill?.service_level ?? {},

        automatic_close_time: dataSkillGetSet.data.skill?.automatic_close_time,
        automatic_close_timeBk:
          dataSkillGetSet.data.skill?.automatic_close_time,

        automatic_transfer_time:
          dataSkillGetSet.data.skill?.automatic_transfer_time,
        automatic_transfer_timeBk:
          dataSkillGetSet.data.skill?.automatic_transfer_time,

        automatic_transfer_skill:
          dataSkillGetSet.data.skill?.automatic_transfer_skill,
        automatic_transfer_skillBk:
          dataSkillGetSet.data.skill?.automatic_transfer_skill,

        client_idle_time: dataSkillGetSet.data.skill?.client_idle_time,
        client_idle_timeBk: dataSkillGetSet.data.skill?.client_idle_time,

        queue_idle_time: dataSkillGetSet.data.skill?.queue_idle_time,
        queue_idle_timeBk: dataSkillGetSet.data.skill?.queue_idle_time,

        agent_idle_time: dataSkillGetSet.data.skill?.agent_idle_time,
        agent_idle_timeBk: dataSkillGetSet.data.skill?.agent_idle_time,

        return_option_close: dataSkillGetSet.data.skill?.return_option_close,
        return_option_closeBk:
          dataSkillGetSet.data.skill?.return_option_closeBk,

        type: dataSkillGetSet.data.skill?.type,
        typeBk: dataSkillGetSet.data.skill?.type,

        widget: dataSkillGetSet.data.skill?.widget,
        widgetBk: dataSkillGetSet.data.skill?.widget,

        channel_phone: dataSkillGetSet.data.skill?.channel_phone,
        channel_phoneBk: dataSkillGetSet.data.skill?.channel_phone,

        sla_count: dataSkillGetSet.data.skill?.sla_count,
        sla_countBk: dataSkillGetSet.data.skill?.sla_count,

        enable_cloning: dataSkillGetSet.data.skill?.enable_cloning,
        enable_cloningBk: dataSkillGetSet.data.skill?.enable_cloning,

        enable_priority: dataSkillGetSet.data.skill?.enable_priority,
        enable_priorityBk: dataSkillGetSet.data.skill?.enable_priority,

        is_ai_summary_enabled: dataSkillGetSet.data.skill?.is_ai_summary_enabled,
        is_ai_summary_enabledBk: dataSkillGetSet.data.skill?.is_ai_summary_enabled,

        enable_lock_skill: dataSkillGetSet.data.skill?.enable_lock_skill,
        enable_lock_skillBk: dataSkillGetSet.data.skill?.enable_lock_skill,       

        objBalancer: {
          balancer: dataSkillGetSet.data.skill?.balancer,
          balancer_timeout: dataSkillGetSet.data.skill?.balancer_timeout,
          balancer_type: dataSkillGetSet.data.skill?.balancer_type,
          balancer_config: dataSkillGetSet.data.skill?.balancer_config?.map(
            (e) =>
              e.carga
                ? { group: { id: e.id, name: e.name }, carga: e.carga }
                : { group: { id: e.id, name: e.name } }
          ),
        },
        objBalancerBk: {
          balancer: dataSkillGetSet.data.skill?.balancer,
          balancer_timeout: dataSkillGetSet.data.skill?.balancer_timeout,
          balancer_type: dataSkillGetSet.data.skill?.balancer_type,
          balancer_config: dataSkillGetSet.data.skill?.balancer_config?.map(
            (e) =>
              e.carga
                ? { group: { id: e.id, name: e.name }, carga: e.carga }
                : { group: { id: e.id, name: e.name } }
          ),
        },
      });
    }
  }, [dataSkillGetSet]);

  useEffect(() => {
    if (dataSkillEditCreate && dataSkillEditCreate.message) {
      showToast("success", t(dataSkillEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successSkill]);

  useEffect(() => {
    if (errorSkill && typeof errorSkill === "object") {
      errorSkill.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorSkill) {
        showToast("error", t(errorSkill));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorSkill]);

  useEffect(() => {
    if (isAutoClose) {
      delete newFields.automatic_transfer_time;
      delete newFields.automatic_transfer_skill;

      if (skillValues.automatic_transfer_skillBk) {
        setNewFields((prev) => ({
          ...prev,
          automatic_close_time: skillValues.automatic_close_time,
        }));
      }
      checkInput("automatic_close_time", skillValues?.automatic_close_time);
    } else {
      delete newFields.automatic_close_time;

      checkAutomaticTransfer({
        value: skillValues.automatic_transfer_time,
        skill: skillValues.automatic_transfer_skill,
      });
    }
  }, [isAutoClose]);

  useEffect(() => {
    checkSubmit();
  }, [newFields]);

  const setClassName = (errors) => {
    return errors ? "av-invalid is-invalid form-control" : "form-control";
  };

  return (
    <React.Fragment>
      <div className="page-content skillPage">
        <Container fluid>
          <Breadcrumbs
            mainPath="/skills"
            path={"/skill"}
            title={t("Skills")}
            breadcrumbItem={idSkill ? t("Edit Skill") : t("Create skill")}
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(newSkillSubmit)}>
                    <Row className="mb-3">
                      <Col xs="12" lg="7" xl="6" className="pr-md-4">
                        <Row>
                          <Col md="6" lg="8">
                            <FormGroup>
                              <Label id="skill-name-label">
                                {t("Name") + " *"}
                              </Label>
                              <input
                                type="text"
                                name="skillname"
                                ref={register}
                                className={setClassName(errors.skillname)}
                                placeholder={t("Enter skill name")}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setSkillValues({
                                    ...skillValues,
                                    name: value,
                                  });
                                  checkInput("name", value);
                                }}
                                defaultValue={skillValues.name}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.skillname?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md="6" lg="4">
                            <FormGroup>
                              <Label id="skill-color">{t("Color")}</Label>
                              <CustomColorPicker
                                className={"form-control"}
                                onChange={(value) => {
                                  setSkillValues({
                                    ...skillValues,
                                    color: value,
                                  });
                                  checkInput("color", value);
                                }}
                                defaultValue={skillValues.color}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="skill-inactive-time"></Label>
                              <InputTime
                                notDays={true}
                                isSeconds={true}
                                notHasBox={true}
                                mb="mb-4"
                                title={t("Inactivity time") + " *"}
                                tooltip={t(
                                  "Maximum time the customer has to answer the agent, otherwise the conversation becomes inactive"
                                )}
                                inputProps={{
                                  name: "skillinactivitytime",
                                  ref: register,
                                  className: setClassName(
                                    errors.skillinactivitytime
                                  ),
                                }}
                                defaultValue={skillValues.inactivity_timeBk}
                                onChange={(val) => {
                                  const value =
                                    val?.value === -1 ? "" : val?.value;
                                  setSkillValues({
                                    ...skillValues,
                                    inactivity_time: value,
                                  });
                                  checkInput("inactivity_time", value);
                                }}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.skillinactivitytime?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <FormGroup>
                              <Label id="skill-active-weight">
                                {t("Active Chat Weight") + " *"}
                              </Label>
                              <CustomInputNumber
                                id="skillactiveweightvalue"
                                name="skillactiveweightvalue"
                                register={register}
                                className={setClassName(
                                  errors.skillactiveweightvalue
                                )}
                                placeholder={`${t(
                                  "Enter number between"
                                )} ${minActiveChat} ${t("and")} ${maxActiveChat}
                                `}
                                step={stepActiveChat}
                                onChange={(value) => {
                                  setSkillValues({
                                    ...skillValues,
                                    weight_active: value,
                                  });
                                  checkInput("weight_active", value);
                                }}
                                defaultValue={skillValues.weight_active}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.skillactiveweightvalue?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md="6">
                            <FormGroup>
                              <Label id="skill-inactive-weight">
                                {t("Inactive Chat Weight") + " *"}
                              </Label>
                              <CustomInputNumber
                                id="skillinactiveweightvalue"
                                name="skillinactiveweightvalue"
                                className={setClassName(
                                  errors.skillinactiveweightvalue
                                )}
                                register={register}
                                placeholder={`${t(
                                  "Enter number between"
                                )} ${minInactiveChat} ${t(
                                  "and"
                                )} ${maxInactiveChat}
                                `}
                                step={stepInactiveChat}
                                onChange={(value) => {
                                  setSkillValues({
                                    ...skillValues,
                                    weight_inactive: value,
                                  });
                                  checkInput("weight_inactive", value);
                                }}
                                defaultValue={skillValues.weight_inactive}
                                isFloat
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.skillinactiveweightvalue?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="skill-sla">{t("SLAs") + " *"}</Label>
                              {loadingSkill ? (
                                <Col md="4">{t("Loading...")}</Col>
                              ) : (
                                dataSkillGetSet?.data?.form?.sla.map(
                                  (item, index) =>
                                    index !== 1 && (
                                      <div
                                        key={index}
                                        ref={() =>
                                          register({
                                            name: `skillslas[${index}].value`,
                                          })
                                        }
                                      >
                                        <InputTime
                                          isSeconds={true}
                                          notHasTitle={true}
                                          notHasBox={true}
                                          description={t(item.name)}
                                          inputProps={{
                                            ref: register,
                                            className: setClassName(
                                              errors &&
                                                errors.skillslas &&
                                                errors.skillslas[index]
                                            ),
                                          }}
                                          defaultValue={item?.value}
                                          onChange={(e) => {
                                            let aux = skillValues.sla.map(
                                              (element) =>
                                                element.id === item.id
                                                  ? {
                                                      ...element,
                                                      value:
                                                        e?.value === -1
                                                          ? ""
                                                          : e?.value,
                                                    }
                                                  : element
                                            );
                                            setValue(
                                              `skillslas[${index}].value`,
                                              e.value
                                            );
                                            setSkillValues({
                                              ...skillValues,
                                              sla: aux,
                                            });

                                            checkSLAs(aux, skillValues.slaBk);
                                          }}
                                        />
                                        <div className="invalid-feedback d-block">
                                          {errors?.skillslas &&
                                            errors.skillslas[index] &&
                                            t(
                                              errors.skillslas[index]?.value
                                                ?.message
                                            )}
                                        </div>
                                      </div>
                                    )
                                )
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="skill-work-days">
                                {t("Work days")}
                              </Label>
                              <CustomDatePicker2
                                type="day"
                                onChange={(value) => {
                                  setSkillValues({
                                    ...skillValues,
                                    schedules: value,
                                  });
                                  checkSchedules(
                                    value,
                                    skillValues.schedulesBk
                                  );
                                }}
                                values={skillValues.schedules}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label id="skills-transfer">
                                {t("Skills Transfer")}
                              </Label>
                              <Select
                                id="skilltransfer"
                                name="skilltransfer"
                                classNamePrefix="select2-selection"
                                placeholder={t("Choose") + "..."}
                                options={optionsSkills()}
                                onChange={(e) => {
                                  let value = e
                                    ? e.map((item) => item.value)
                                    : [];
                                  setSkillValues({
                                    ...skillValues,
                                    transfer: value,
                                  });
                                  checkSelects(
                                    value,
                                    skillValues.transferBk,
                                    "transfer"
                                  );
                                }}
                                value={optionsSkills()?.filter((element) =>
                                  skillValues?.transfer?.includes(element.value)
                                )}
                                isMulti
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label id="skill-fallback">
                                {t("Skill Fallback")}
                              </Label>
                              <div
                                ref={() => register({ name: "noAgent" })}
                                className="custom-control custom-checkbox"
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  checked={skillValues.fallback_no_agents}
                                  readOnly
                                />
                                <label
                                  className="custom-control-label"
                                  onClick={() => {
                                    const value =
                                      !skillValues.fallback_no_agents;
                                    if (skillValues.fallback) {
                                      setSkillValues((prev) => ({
                                        ...prev,
                                        fallback_no_agents: value,
                                      }));
                                      checkInput("fallback_no_agents", value);
                                    }
                                  }}
                                >
                                  {t(
                                    "Apply fallback if there is no agent online"
                                  )}
                                </label>
                              </div>
                              <Select
                                id="skillfallback"
                                name="skillfallback"
                                className="mt-2"
                                classNamePrefix="select2-selection"
                                placeholder={t("Choose") + "..."}
                                options={optionsSkills()}
                                onChange={(e) => {
                                  let value = e?.value ?? null;
                                  if (value) {
                                    setSkillValues({
                                      ...skillValues,
                                      fallback: value,
                                    });
                                  } else {
                                    setSkillValues({
                                      ...skillValues,
                                      fallback: value,
                                      fallback_no_agents: false,
                                    });
                                    checkInput("fallback_no_agents", false);
                                  }
                                  checkSelects(
                                    value,
                                    skillValues.fallbackBk,
                                    "fallback"
                                  );
                                }}
                                value={
                                  optionsSkills()?.find(
                                    (e) => e.value === skillValues?.fallback
                                  ) ?? null
                                }
                                isClearable={true}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label id="skill-sl">{t("Service level")}</Label>
                              <Row>
                                <Col>
                                  <Label>{t("aTime")}</Label>
                                  <InputGroup>
                                    <input
                                      name="skillsltime"
                                      ref={() =>
                                        register({ name: "skillsltime" })
                                      }
                                      className={setClassName(
                                        errors.skillsltime
                                      )}
                                      placeholder={t(
                                        "Enter SL time in seconds"
                                      )}
                                      onChange={(e) => {
                                        const value = e?.target?.value
                                          ? parseInt(e?.target?.value, 10)
                                          : null;

                                        setValue("skillsltime", value, {
                                          shouldValidate: true,
                                        });

                                        setValue("skillslgoal", null, {
                                          shouldValidate: true,
                                        });

                                        const newServiceLevel = {
                                          time: value,
                                          goal: null,
                                        };

                                        setSkillValues({
                                          ...skillValues,
                                          service_level: newServiceLevel,
                                        });

                                        if (
                                          isEqual(
                                            newServiceLevel,
                                            skillValues?.service_levelBk
                                          )
                                        ) {
                                          delete newFields.service_level;
                                          checkSubmit();
                                        } else {
                                          setNewFields((prev) => ({
                                            ...prev,
                                            service_level: newServiceLevel,
                                          }));
                                        }
                                      }}
                                      value={
                                        skillValues?.service_level?.time || null
                                      }
                                    />
                                    <span className="input-group-append">
                                      <span className="input-group-text">
                                        {t("seconds")}
                                      </span>
                                    </span>
                                  </InputGroup>
                                  <div className="invalid-feedback d-block">
                                    {t(errors.skillsltime?.message)}
                                  </div>
                                </Col>
                                <Col>
                                  <Label>{t("Goal")}</Label>
                                  <InputGroup>
                                    <input
                                      name="skillslgoal"
                                      ref={() =>
                                        register({ name: "skillslgoal" })
                                      }
                                      className={setClassName(
                                        errors.skillslgoal
                                      )}
                                      placeholder={t("Enter SL goal percent")}
                                      onChange={(e) => {
                                        const value = e?.target?.value
                                          ? parseInt(e?.target?.value, 10)
                                          : null;

                                        setValue("skillslgoal", value, {
                                          shouldValidate: true,
                                        });

                                        const newServiceLevel = {
                                          ...skillValues.service_level,
                                          goal: value,
                                        };

                                        setSkillValues({
                                          ...skillValues,
                                          service_level: newServiceLevel,
                                        });

                                        if (
                                          isEqual(
                                            newServiceLevel,
                                            skillValues?.service_levelBk
                                          )
                                        ) {
                                          delete newFields.service_level;
                                          checkSubmit();
                                        } else {
                                          setNewFields((prev) => ({
                                            ...prev,
                                            service_level: newServiceLevel,
                                          }));
                                        }
                                      }}
                                      value={
                                        skillValues?.service_level?.goal || ""
                                      }
                                      disabled={
                                        !skillValues?.service_level?.time
                                      }
                                    />
                                    <span className="input-group-append">
                                      <span className="input-group-text">
                                        %
                                      </span>
                                    </span>
                                  </InputGroup>
                                  <div className="invalid-feedback d-block">
                                    {t(errors.skillslgoal?.message)}
                                  </div>
                                </Col>
                              </Row>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label id="skill-csat">{t("CSAT")}</Label>
                              <Select
                                id="skillcsat"
                                name="skillcsat"
                                classNamePrefix="select2-selection"
                                placeholder={t("Choose") + "..."}
                                options={getOptions("csat")}
                                onChange={(e) => {
                                  let value = e?.value ?? null;
                                  setSkillValues({
                                    ...skillValues,
                                    csat_id: value,
                                  });
                                  checkSelects(
                                    value,
                                    skillValues.csat_idBk,
                                    "csat_id"
                                  );
                                }}
                                value={getOptions("csat").find(
                                  (item) => item.value === skillValues.csat_id
                                )}
                                isClearable={true}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <Label id="skill-users">{t("Skill Users")}</Label>
                              <Select
                                id="skillusers"
                                name="skillusers"
                                classNamePrefix="select2-selection"
                                placeholder={t("Choose") + "..."}
                                options={getOptions("users")}
                                onChange={(e) => {
                                  let value = e
                                    ? e.map((item) => item.value)
                                    : [];
                                  setSkillValues({
                                    ...skillValues,
                                    users: value,
                                  });
                                  checkSelects(
                                    value,
                                    skillValues.usersBk,
                                    "users"
                                  );
                                }}
                                value={getOptions("users")?.filter((element) =>
                                  skillValues?.users?.includes(element.value)
                                )}
                                isMulti
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="skill-queue-priority">
                                {t("Queue Priority")}
                              </Label>
                              <Row className="d-flex">
                                {loadingSkill ? (
                                  <Col md="4">{t("Loading...")}</Col>
                                ) : (
                                  dataSkillGetSet &&
                                  dataSkillGetSet.data &&
                                  dataSkillGetSet.data.form &&
                                  dataSkillGetSet.data.form.queue_priority.map(
                                    (item, index) =>
                                      index !== 2 && (
                                        <Col md="6" key={index}>
                                          <div className="d-flex justify-content-between w-100">
                                            <Label
                                              id={item.id}
                                              className="d-flex control-label font-weight-light"
                                            >
                                              {t(
                                                dataSkillGetSet.data.form
                                                  .queue_priority[index].name
                                              )}
                                            </Label>
                                            <div className="custom-control custom-checkbox">
                                              <input
                                                type="checkbox"
                                                name={`skillqueuepriority[${index}].factor`}
                                                className="custom-control-input"
                                                ref={register}
                                                checked={
                                                  skillValues &&
                                                  skillValues.queuepriority &&
                                                  skillValues.queuepriority
                                                    .length > 0
                                                    ? skillValues.queuepriority[
                                                        index
                                                      ].factor === "power"
                                                      ? true
                                                      : false
                                                    : dataSkillGetSet.data.form
                                                        .queue_priority[index]
                                                        .factor === "power"
                                                    ? true
                                                    : false
                                                }
                                                readOnly
                                              />
                                              <label
                                                className="custom-control-label"
                                                id="power-checkbox"
                                                onClick={() => {
                                                  let aux =
                                                    skillValues.queuepriority.map(
                                                      (element) =>
                                                        element.id === item.id
                                                          ? {
                                                              ...element,
                                                              factor:
                                                                element.factor ===
                                                                "multi"
                                                                  ? "power"
                                                                  : "multi",
                                                            }
                                                          : element
                                                    );
                                                  setSkillValues({
                                                    ...skillValues,
                                                    queuepriority: aux,
                                                  });
                                                  checkQueuePriorities(
                                                    aux,
                                                    skillValues.queuepriorityBk
                                                  );
                                                }}
                                              >
                                                {t("Turn On")}
                                              </label>
                                            </div>
                                          </div>
                                          <CustomInputNumber
                                            id={`id${item.id}`}
                                            name={`skillqueuepriority[${index}].value`}
                                            className={setClassName(
                                              errors &&
                                                errors.skillqueuepriority &&
                                                errors.skillqueuepriority[index]
                                            )}
                                            register={register}
                                            placeholder={`${t(
                                              "Enter number between"
                                            )} ${minQueuePriority} ${t(
                                              "and"
                                            )} ${maxQueuePriority}
                                          `}
                                            step={stepQueuePriority}
                                            onChange={(value) => {
                                              let aux =
                                                skillValues.queuepriority.map(
                                                  (element) =>
                                                    element.id === item.id
                                                      ? {
                                                          ...element,
                                                          value: value
                                                            ? value
                                                            : minQueuePriority,
                                                        }
                                                      : element
                                                );
                                              setSkillValues({
                                                ...skillValues,
                                                queuepriority: aux,
                                              });
                                              checkQueuePriorities(
                                                aux,
                                                skillValues.queuepriorityBk
                                              );
                                            }}
                                            defaultValue={item.value}
                                          />
                                          <div className="invalid-feedback d-block">
                                            {errors?.skillqueuepriority &&
                                              errors.skillqueuepriority[
                                                index
                                              ] &&
                                              t(
                                                errors.skillqueuepriority[index]
                                                  .value.message
                                              )}
                                          </div>
                                          <UncontrolledTooltip
                                            placement="auto"
                                            target="power-checkbox"
                                          >
                                            {t(
                                              "Select this option if you want a skill to have exponential priority"
                                            )}
                                          </UncontrolledTooltip>
                                        </Col>
                                      )
                                  )
                                )}
                              </Row>
                            </FormGroup>
                          </Col>
                          <Col xs="12">
                            <BalancingComponent
                              value={skillValues?.objBalancer}
                              defaultValue={skillValues?.objBalancerBk}
                              groups={dataSkillGetSet?.data?.form?.groups}
                              onChange={(val) => {
                                if (val.balancer_timeout > 0) {
                                  val.balancer_timeout = parseInt(
                                    val.balancer_timeout
                                  );
                                }

                                if (isEqual(val, skillValues?.objBalancerBk)) {
                                  delete newFields.objBalancer;
                                  checkSubmit();
                                } else {
                                  setNewFields((prev) => ({
                                    ...prev,
                                    objBalancer: val,
                                  }));
                                }
                                setSkillValues((prev) => ({
                                  ...prev,
                                  objBalancer: val,
                                }));
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs="12" lg="5" xl="6" className="pl-xl-4">
                        {chatEvents()}
                      </Col>
                    </Row>
                    <div className="tooltips-triggers">
                      <UncontrolledTooltip
                        placement="auto"
                        target="skill-name-label"
                      >
                        {t("Skill name")}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip
                        placement="auto"
                        target="skill-color"
                      >
                        {t("Skill badge color")}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip
                        placement="auto"
                        target="skill-work-days"
                      >
                        {t("Days when skill is available to recive calls")}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip
                        placement="auto"
                        target="skills-transfer"
                      >
                        {t(
                          "Skill to which the agent can trasfer the convesation"
                        )}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip
                        placement="auto"
                        target="skill-fallback"
                      >
                        {t(
                          "Skill to which the conversation is transferred if there is no agent on current skill"
                        )}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip
                        placement="auto"
                        target="skill-users"
                      >
                        {t("Users who have this skill")}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip
                        placement="auto"
                        target="skill-active-weight"
                      >
                        {t(
                          "Active chat weight is use on queue equation. The number of active conversations is multiplied by the chosen weight. Condition for receiving new conversations (number of active conversations x weight of active conversations + number of inactive conversations x weight of inactive conversations) <maximum number of user conversations"
                        )}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip
                        placement="auto"
                        target="skill-inactive-weight"
                      >
                        {t(
                          "Inactive chat weight is use on queue equation. The number of inactive conversations is multiplied by the chosen weight. Condition for receiving new conversations (number of active conversations x weight of active conversations + number of inactive conversations x weight of inactive conversations) <maximum number of user conversations"
                        )}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip
                        placement="auto"
                        target="skill-inactive-time"
                      >
                        {t(
                          "Maximum time the customer has to answer the agent, otherwise the conversation becomes inactive"
                        )}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip placement="auto" target="skill-sla">
                        {t(
                          "Time the agent has to respond to the customer with each new message"
                        )}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip
                        placement="auto"
                        target="skill-queue-priority"
                      >
                        {t("Queue priority")}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip placement="auto" target="skill-csat">
                        {t(
                          "Satisfaction survey sent at the end of each conversation"
                        )}
                      </UncontrolledTooltip>
                      <UncontrolledTooltip placement="auto" target="skill-sl">
                        {t(
                          "CALCULATION: [total assigned conversations within target time] / [total assigned conversations in skill]"
                        )}
                      </UncontrolledTooltip>
                    </div>

                    <Row>
                      <Col xs="12" className="text-right">
                        <Button
                          type="submit"
                          color="primary"
                          className="mr-2 waves-effect waves-light"
                          style={{
                            minWidth: "100px",
                            cursor: enableSubmit ? "pointer" : "no-drop",
                          }}
                          disabled={!enableSubmit}
                        >
                          {loadingSkillEditCreate ? (
                            <Spinner
                              size="sm"
                              animation="border"
                              style={{
                                height: "19px",
                                width: "19px",
                              }}
                            />
                          ) : (
                            t("Confirm")
                          )}
                        </Button>
                        <Link to="/skills">
                          <Button
                            type="button"
                            color="secondary"
                            className="waves-effect btn-dark"
                            onClick={() => dispatch(resetSkill())}
                          >
                            {t("Cancel")}
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewSkill);
